export default "__VITE_ASSET__4Ww_PLyR__"